import React from 'react';

export const styles = {
	colors: {
		eggShell: 'rgb(242, 235, 211)',
		white: '#fff',
		black: '#000'
	},
	font: {
		fontWeight: 'bold'
	}
};

export const OpacityContext = React.createContext(1);